<template>
    <div class="row">
        <div class="col-md-12 mb-1">
            <label class="form-label">Aylak İli</label>
            <v-select-list v-model="value.Province" :options="provinces" label="Name" v-on:input="getDistricts" placeholder="Aylak İli"></v-select-list>
        </div>
        <div class="col-md-12 mb-1">
            <label class="form-label">Aylak İlçesi</label>
            <v-select-list :disabled="!value.Province" v-model="value.District" :options="districts" label="Name" placeholder="Aylak İlçesi"></v-select-list>
        </div>
    </div>
</template>

<script>
import SystemDataApi from '@/api/system-data'
export default {
    props:{
        value:Object
    },
    components:{
    },
    data(){
        return{
            provinces:[],
            districts:[],
        }
    },
    mounted(){
        this.getProvinces()
    },
    watch:{
        "value.Province":{
            handler(){
                this.value.District = null
            }
        },
    },
    methods:{
        getProvinces(){
            SystemDataApi.ProvinceByCountry('43776974-AB91-4FA2-B2AC-87B5E8939241').then(response=>{
                this.provinces = response.data.Data
            })
        },
        getDistricts(){
            if(this.value.Province?.Id){
                SystemDataApi.District(this.value.Province.Id)
                .then(res=>{
                    this.districts = res.data.Data
                })
            }
        }
    },

}
</script>

<style>

</style>